const carousel = {};

document.addEventListener('change', (event) => {
    // Contact selector value changed
    if (event.target.id == 'keyContact') {
        updateKeyContact(event.target.value);
        // updateFooterContact(event.target.value);
        updateModalContact(event.target.value);
        updateMobileKeyContact(event.target.value, false);
    }
    let length = document.querySelector(`#keyContact option[value="${event.target.value}"]`).innerHTML.trim().length;
    document.querySelector('#keyContact').style.width = length < 8 ? (length + 4.5) + 'ch' : (length + 3) + 'ch';
}, false);

document.addEventListener('click', (event) => {
    // Contact selector value changed
    if (event.target.classList.contains('mobile-key-contacts-selector')) {
        let regionId = event.target.parentNode.getAttribute('data-region-id');
        let contactId = event.target.parentNode.getAttribute('data-contact-id');

        updateKeyContact(regionId, contactId);
        // updateFooterContact(regionId, contactId);
        updateModalContact(regionId, contactId);
        updateMobileKeyContact(regionId, true, contactId);
    }
}, false);

document.addEventListener('show.bs.tab', event => {
    if (event.target.classList.contains('stats-nav')) {
        const btn = document.querySelector(`.stats-dropdown-item[data-stat-tab-id="${event.target.dataset.bsTarget}"]`);
        if (btn) {
            btn.click();
        }
    }
});

const updateMobileKeyContact = (regionId, close = true, contactId = null) => {
    let newContact            = document.querySelector(`.mobile-key-contacts[data-region-id="${regionId}"]`);
    let currentContact        = document.querySelector('#mobile-key-contact-selected');
    let currentContactImg     = document.querySelector('#mobile-key-contact-selected-img-container');
    let currentContactDetails = document.querySelector('#mobile-key-contact-selected-details-container');
    let tempContact           = newContact.cloneNode(true);

    if (contactId != null) {
        newContact  = document.querySelector(`.mobile-key-contacts[data-region-id="${regionId}"][data-contact-id="${contactId}"]`);
        tempContact = newContact.cloneNode(true);
    }

    newContact.childNodes.forEach(node => {
        if (node.nodeName != '#text' && node.classList) {
            if (node.classList.contains('mobile-key-contacts-details-container')) {
                node.innerHTML = currentContactDetails.innerHTML;
            } else if (node.classList.contains('mobile-key-contacts-img-container')) {
                node.innerHTML = currentContactImg.innerHTML;
            }
        }
    });
    newContact.dataset.regionId = currentContact.dataset.regionId;
    newContact.dataset.contactId = currentContact.dataset.contactId;

    tempContact.childNodes.forEach(node => {
        if (node.nodeName != '#text' && node.classList) {
            if (node.classList.contains('mobile-key-contacts-details-container')) {
                currentContactDetails.innerHTML = node.innerHTML;
            } else if (node.classList.contains('mobile-key-contacts-img-container')) {
                currentContactImg.innerHTML = node.innerHTML;
            }
        }
    });
    currentContact.dataset.regionId  = tempContact.dataset.regionId;
    currentContact.dataset.contactId = tempContact.dataset.contactId;

    if (close) {
        document.querySelector('[href="#mobile-key-contacts-collapse"').click();
        document.querySelector('#keyContact').value = regionId;
    }
}

const updateKeyContact = (selectedRegionId, selectedContactId = null) => {
    // Update key contact
    document.querySelectorAll('.region-contact-carousel')
        .forEach((element) => {
            if (element.dataset.regionId == selectedRegionId) {
                element.classList.remove('invisible');
                element.querySelectorAll('.carousel-fixed-item div.region-contacts div:first-of-type, .carousel-fixed-item div.carousel-controls, .carousel-item')
                    .forEach(function (el) {
                        el.classList.remove('invisible', 'd-none')
                    });

                if (selectedContactId != null) {
                    element.querySelectorAll('.carousel-fixed-item div.region-contacts div.region-contact')
                        .forEach(function (el) {
                            if (el.dataset.contactId == selectedContactId) {
                                el.classList.remove('invisible', 'd-none')
                            } else if (!el.parentNode.classList.contains('.carousel-item')) {
                              el.classList.add('invisible')
                            }
                        });

                    element.querySelectorAll('.carousel-item img')
                        .forEach(function (el, key) {
                            if (el.dataset.contactId == selectedContactId) {
                                carousel[selectedRegionId].set(key);
                            }
                        });
                }
            } else {
                element.classList.add('invisible');
                element.querySelectorAll('.carousel-fixed-item div.region-contacts div, .carousel-fixed-item div.region-contacts div.carousel-controls, .carousel-item')
                  .forEach(function (el) {
                    el.classList.add('invisible')
                  })
            }
        });
}

const updateFooterContact = (selectedRegionId, selectedContactId = null) => {
    // Update footer key contact
    if (typeof marketoFormFooter != 'undefined' && marketoFormFooter != null) {
        marketoFormFooter.addHiddenFields({
          formRequestRecipientEmail: '',
        });
    }

    let found = false;
    document.querySelectorAll('.footer-region-contact')
        .forEach((element) => {
            if (!found
              && element.dataset.regionId == selectedRegionId
              && (selectedContactId == null || element.dataset.contactId == selectedContactId)
            ) {
                found = true;
                element.classList.remove('d-none');
                if (typeof marketoFormFooter != 'undefined' && marketoFormFooter != null) {
                    marketoFormFooter.addHiddenFields({
                        formRequestRecipientEmail: element.dataset.contactEmail
                    });
                }
            } else {
                element.classList.add('d-none');
            }
        });
}

const updateModalContact = (selectedRegionId, selectedContactId = null) => {
    // Update modal key contact
    if (typeof marketoFormModal != 'undefined' && marketoFormModal != null) {
        marketoFormModal.addHiddenFields({
            formRequestRecipientEmail: '',
        });
    }

    let found = false;
    document.querySelectorAll('.modal-region-contact')
        .forEach((element) => {
            if (!found
              && element.dataset.regionId == selectedRegionId
              && (selectedContactId == null || element.dataset.contactId == selectedContactId)
            ) {
                found = true;
                element.classList.remove('d-none');
                if (typeof marketoFormModal != 'undefined' && marketoFormModal != null) {
                    marketoFormModal.addHiddenFields({
                        formRequestRecipientEmail: element.dataset.contactEmail,
                    });
                }
            } else {
                element.classList.add('d-none');
            }
        });
}

document.addEventListener('DOMContentLoaded', function() {
  var elems = document.querySelectorAll('.region-contact-carousel');

  elems.forEach(function (el) {
      let carouselInstance = M.Carousel.init(
          el,
          {
              dist: 0,
              numVisible: 4,
              padding: -300,
              onCycleTo: function (slideEl) {
                  let contactId = slideEl.querySelector('img').dataset.contactId;
                  let regionId  = slideEl.querySelector('img').dataset.regionId;
                  if (!!contactId) {
                      el.querySelectorAll('.region-contacts .region-contact')
                          .forEach(function (regionContactEl) {
                              if (regionContactEl.dataset.contactId == contactId) {
                                  regionContactEl.classList.remove('d-none', 'invisible');
                              } else {
                                  regionContactEl.classList.add('d-none', 'invisible');
                              }
                          });

                      document.querySelectorAll('.footer-region-contact')
                          .forEach(function (footerRegionContact) {
                              if (
                                  footerRegionContact.dataset.regionId == regionId
                                  && footerRegionContact.dataset.contactId == contactId
                              ) {
                                  footerRegionContact.classList.remove('d-none');
                                  if (typeof marketoFormFooter != 'undefined' && marketoFormFooter != null) {
                                      marketoFormFooter.addHiddenFields({
                                          formRequestRecipientEmail: footerRegionContact.dataset.contactEmail
                                      });
                                  }
                              } else {
                                  footerRegionContact.classList.add('d-none');
                              }
                          });

                      document.querySelectorAll('.modal-region-contact')
                          .forEach(function (modalRegionContact) {
                              if (
                                  modalRegionContact.dataset.regionId == regionId
                                  && modalRegionContact.dataset.contactId == contactId
                              ) {
                                  modalRegionContact.classList.remove('d-none');
                                  if (typeof marketoFormModal != 'undefined' && marketoFormModal != null) {
                                      marketoFormModal.addHiddenFields({
                                          formRequestRecipientEmail: modalRegionContact.dataset.contactEmail
                                      });
                                  }
                              } else {
                                  modalRegionContact.classList.add('d-none');
                              }
                          });
                  }
              }
          }
      );

      carouselInstance.$el[0].removeEventListener('mousedown', carouselInstance._handleCarouselTapBound);
      carouselInstance.$el[0].removeEventListener('mousemove', carouselInstance._handleCarouselDragBound);
      carouselInstance.$el[0].removeEventListener('mouseup', carouselInstance._handleCarouselReleaseBound);
      carouselInstance.$el[0].removeEventListener('mouseleave', carouselInstance._handleCarouselReleaseBound);
      carouselInstance.$el[0].removeEventListener('click', carouselInstance._handleCarouselClickBound);

      carousel[el.dataset.regionId] = carouselInstance

      let prevBtn = el.querySelector('.carousel-controls .prev');

      if (!!prevBtn) {
        prevBtn.addEventListener('click', function() {
          carouselInstance.prev();
        });
      }

      let nextBtn = el.querySelector('.carousel-controls .next');

      if (!!nextBtn) {
        nextBtn.addEventListener('click', function() {
          carouselInstance.next();
        });
      }
  });

  if (
    typeof window.initSelectedRegionId != 'undefined'
    && window.initSelectedRegionId != null
    && window.initSelectedRegionId != ''
  ) {
      updateModalContact(window.initSelectedRegionId, null);
  }
});
